
export class UtilData {

    static formataData(data, reverter = false) {
        let dateObj;

        if (data && typeof data !== 'string') {
            if (data.date) {
                dateObj = new Date(
                    data.date.year,
                    data.date.month - 1, // mês começa em 0
                    data.date.day,
                    data.time.hour,
                    data.time.minute,
                    data.time.second
                );
            } else {
                dateObj = new Date(data);
            }
        } else if (typeof data === 'string') {
            dateObj = new Date(data);
        }

        if (!dateObj || isNaN(dateObj.getTime())) {
            return '';
        }

        const dia = this.pad(dateObj.getDate());
        const mes = this.pad(dateObj.getMonth() + 1);
        const ano = dateObj.getFullYear();
        const hora = this.pad(dateObj.getHours());
        const minuto = this.pad(dateObj.getMinutes());

        const dataFormatada = `${dia}/${mes}/${ano} ${hora}:${minuto}`;

        if (reverter) {
            return `${ano}/${mes}/${dia} ${hora}:${minuto}`;
        }

        return dataFormatada;
    }

    static pad = (n) => String(n).padStart(2, '0')

    static dataSemHora(data) {
        const retorno = this.formataData(data);
        return retorno.split(' ')[0];
    }

    static toBR(data: Date) {
        return this.formataData(data);
    }
}